import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

export function ColorTemplateIcon({ height, width }: SimpleIconInterface): JSX.Element {
  const gradientId = useSvgId('color-template-gradient');

  return (
    <SimpleIcon height={height ?? 24} viewBoxDimensions="0 0 24 24" width={width ?? 24}>
      <defs>
        <linearGradient id={gradientId} x1="93.556%" x2="24.176%" y1="0%" y2="81.856%">
          <stop offset="0%" stopColor="#146EE8" />
          <stop offset="100%" stopColor="#3942B7" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g fill={`url(#${gradientId})`} transform="translate(-282 -417)">
          <g>
            <path
              d="M21.625 20.938c0 .759-.616 1.375-1.375 1.375H3.75c-.76 0-1.375-.616-1.375-1.375V3.063c0-.76.616-1.376 1.375-1.376h13.791c.36 0 .704.14.96.391l2.709 2.643c.265.259.415.614.415.984v15.233zM7 15.25h10c.138 0 .25.112.25.25V17c0 .138-.112.25-.25.25H7c-.138 0-.25-.112-.25-.25v-1.5c0-.138.112-.25.25-.25zm0-1.5c-.966 0-1.75.784-1.75 1.75V17c0 .966.784 1.75 1.75 1.75h10c.966 0 1.75-.784 1.75-1.75v-1.5c0-.966-.784-1.75-1.75-1.75H7zm-1-2.5h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H6c-.414 0-.75.336-.75.75s.336.75.75.75zm5 0h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H11c-.414 0-.75.336-.75.75s.336.75.75.75zm5 0h2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2c-.414 0-.75.336-.75.75s.336.75.75.75zm-10-4h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H6c-.414 0-.75.336-.75.75s.336.75.75.75zm5 0h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H11c-.414 0-.75.336-.75.75s.336.75.75.75z"
              transform="translate(282 417)"
            />
          </g>
        </g>
      </g>
    </SimpleIcon>
  );
}
